// extracted by mini-css-extract-plugin
export default {"wrap":"item-module_wrap_h1AQ6","label":"item-module_label_ETdMR","value":"item-module_value_rrhma","error":"item-module_error_jq44H"};